var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 16C30 18.7689 29.1789 21.4757 27.6406 23.778C26.1022 26.0803 23.9157 27.8747 21.3576 28.9343C18.7994 29.9939 15.9845 30.2712 13.2687 29.731C10.553 29.1908 8.05844 27.8574 6.10051 25.8995C4.14258 23.9416 2.80921 21.447 2.26901 18.7313C1.72882 16.0155 2.00607 13.2006 3.06569 10.6424C4.12532 8.08427 5.91973 5.89776 8.22202 4.35943C10.5243 2.82109 13.2311 2 16 2C19.7118 2.00401 23.2704 3.4803 25.8951 6.10494C28.5197 8.72958 29.996 12.2882 30 16ZM18.3333 16C18.3333 15.3812 18.0875 14.7877 17.6499 14.3501C17.2123 13.9125 16.6188 13.6667 16 13.6667H13.6667V16H16V24.1667H18.3333V16ZM16 7.83333C15.6539 7.83333 15.3155 7.93597 15.0278 8.12826C14.74 8.32055 14.5157 8.59387 14.3832 8.91364C14.2508 9.23341 14.2161 9.58527 14.2836 9.92474C14.3512 10.2642 14.5178 10.576 14.7626 10.8208C15.0073 11.0655 15.3191 11.2322 15.6586 11.2997C15.9981 11.3672 16.3499 11.3326 16.6697 11.2001C16.9895 11.0677 17.2628 10.8434 17.4551 10.5556C17.6474 10.2678 17.75 9.92945 17.75 9.58333C17.75 9.1192 17.5656 8.67408 17.2374 8.3459C16.9093 8.01771 16.4641 7.83333 16 7.83333Z",
    fill: "#2F5188"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.2fe21963403afcc6fd2d57d6c873a930.svg";
export { ForwardRef as ReactComponent };